import React, { useEffect, useState } from "react";
import { useUserContext } from "../context/UserContext";
import AdminDashboard from "./AdminDashboard";
import UserDashboard from "./UserDashboard";
import SupervisorDashboard from "./SupervisorDashboard";
import { getUserEmail } from "../utils/sessionCheck";
import { getSupervisedUsers } from "../context/Api";

const Dashboard = () => {
  const { userRole } = useUserContext();
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [loading, setLoading] = useState(true);
  const userEmail = getUserEmail();

  useEffect(() => {
    const checkSupervisorStatus = async () => {
      if (!userEmail || userRole === "SuperAdmin" || userRole === "admin") {
        setLoading(false);
        return;
      }

      try {
        const supervisedUsers = await getSupervisedUsers(userEmail);
        setIsSupervisor(supervisedUsers.length > 0);
      } catch (error) {
        console.error("Error checking supervisor status:", error);
        setIsSupervisor(false);
      } finally {
        setLoading(false);
      }
    };

    checkSupervisorStatus();
  }, [userEmail, userRole]);

  if (loading) {
    return <div>Loading...</div>;
  }

  const isAdmin = userRole === "admin" || userRole === "SuperAdmin";

  if (isAdmin) {
    return <AdminDashboard />;
  }

  if (isSupervisor) {
    return <SupervisorDashboard />;
  }

  return <UserDashboard />;
};

export default Dashboard;


